import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const headerAvatar = style({
  flexShrink: 0,
  cursor: 'pointer',
  marginLeft: space.s10,
});
